var icon = require('vue-svgicon')
icon.register({
  'ionicons/ios-calendar-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" class="st0" d="M80 112v64h352v-64"/><path pid="1" d="M352 96V64h-16v32H176V64h-16v32H64v352h384V96h-96zm80 336H80V192h352v240zm0-256H80v-64h80v32h16v-32h160v32h16v-32h80v64z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/ionicons/ios-calendar-outline.js